import { Dimension } from 'src/@enums'
import { BusinessUnitShortType } from 'src/@types'
import { gaEvent, getDimensionByUnit } from 'src/utils'

const RESELLER_USER_TYPE = 'revendedor'
const CUSTOMER_USER_TYPE = 'cliente'

/**
 * Parâmetro para {@link dimensionUserTypeEvent}
 *
 * @param isAuthenticated diz se o usuário está autenticado ou não
 */
export type DimensionUserTypeEventType = BusinessUnitShortType & {
  isAuthenticated: boolean
}

/**
 * [TARGET]: Emite a dimensão (evento no google analytics) para dizer qual o tipo de usuário
 *
 * [REGRAS]: Caso o usuário está autenticado ele é um revendor, senão é cliente. Pois somente revendedor pode se autenticar.
 */

export const dimensionUserTypeEvent = ({
  isAuthenticated,
  businessUnit,
}: DimensionUserTypeEventType): void => {
  gaEvent({
    [getDimensionByUnit(Dimension.USER_TYPE, businessUnit)]: isAuthenticated
      ? RESELLER_USER_TYPE
      : CUSTOMER_USER_TYPE,
  })
}
